import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { loganUTConfig } from "./data";

export default function LoganUTPage() {
  return <CityPageTemplate config={loganUTConfig} />;
}